import { ClipboardList, Clock, ShieldCheck, TrendingUp, ArrowDown } from "lucide-react";
import { METHOD_POINTS, IMAGES } from "../data/content";
import { Reveal } from "../components/Reveal";
import { scrollToTarget } from "../lib/scroll";

const BgHero = ({ src }) => (
  <>
    <img src={src} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 h-full w-full object-cover blur-3xl scale-125 opacity-35" />
    <div className="absolute inset-0 bg-[#050505]/55" aria-hidden="true" />
    <img src={src} alt="" aria-hidden="true" loading="lazy" className="absolute inset-y-0 right-0 h-full w-full object-contain object-center lg:object-right opacity-90" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/70 to-transparent" aria-hidden="true" />
    <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-transparent to-[#050505]" aria-hidden="true" />
  </>
);

const ICONS = [ClipboardList, Clock, ShieldCheck, TrendingUp];

const Method = () => (
  <section id="metodo" data-testid="rnb-method-section" className="relative py-20 lg:py-32 bg-[#050505] overflow-hidden">
    <BgHero src={IMAGES.editorial.bgStudio} />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs tracking-[0.4em] text-zinc-500 uppercase">No es solo un plan, es un método</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] max-w-3xl">
          Real Natural Bodybuilding es tu camino hacia resultados reales,{" "}
          <span className="text-zinc-500">sin trampas y para siempre.</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
        {METHOD_POINTS.map((p, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={p.num} delay={0.1 + i * 0.08} className="h-full">
              <div
                data-testid={`rnb-method-card-${i + 1}`}
                className="group h-full border border-zinc-800/80 bg-[#0D0D0D] p-7 transition-colors duration-300 hover:border-zinc-500"
              >
                <div className="flex items-start justify-between">
                  <span className="font-display text-5xl text-zinc-800 group-hover:text-zinc-600 transition-colors">{p.num}</span>
                  <Icon className="h-6 w-6 text-zinc-500 group-hover:text-white transition-colors" />
                </div>
                <h3 className="mt-8 font-display text-2xl tracking-wide text-white">{p.title}</h3>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
      <Reveal delay={0.3} className="mt-12 text-center">
        <button
          onClick={() => scrollToTarget("#coaching-vip")}
          data-testid="rnb-method-cta"
          className="group inline-flex items-center gap-3 bg-white text-black font-display text-xl tracking-[0.15em] px-8 py-4 hover:bg-zinc-200 transition-colors"
        >
          EMPIEZA CON EL MÉTODO
          <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-1" />
        </button>
      </Reveal>
    </div>
  </section>
);

export default Method;
